import {
  SET_TEAM_NAME,
  SET_USER_NAME,
  SET_PASSWORD,
  SET_MESSAGE
} from '../../actions/page/XLogin';
import {
  GET_AUTH_INFO_REQUEST,
  GET_AUTH_INFO_SUCCESS,
  GET_AUTH_INFO_FAILURE
} from '../../actions/api/team';

export default function XLogin(state = {}, action) {
  switch (action.type) {
    case SET_TEAM_NAME:
      return {
        ...state,
        teamName: action.teamName
      };
    case SET_USER_NAME:
      return {
        ...state,
        userName: action.userName
      };
    case SET_PASSWORD:
      return {
        ...state,
        password: action.password
      };
    case SET_MESSAGE:
      return {
        ...state,
        message: action.message,
        error: action.error
      };
    case GET_AUTH_INFO_REQUEST:
      return {
        ...state,
        loading: true
      };
    case GET_AUTH_INFO_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case GET_AUTH_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        message: action.message,
        error: action.error
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/XLogin.js